export default __webpack_public_path__ + "static/media/lightgreen.fe67d659.png";